import React from "react";
import ArticleButtons from "../ArticleButtons";

export default function HardcodedEndColumnTDs(props) {
  return (
    <td className="c-parts-listing__table-item">
      <ArticleButtons
        onDownload={(data) => props.openDownloadModal(data, props.row)}
        models={props.row.modelFiles}
        drawings={props.row.drawingFiles}
        row={props.row}
      />
    </td>
  );
}
